import React from "react";
import PopupWindow from "components/PopupWindow";

const TermsOfUseModal = ({
  showTermsOfUse,
  setShowTermsOfUse,
  handleLogout,
}) => {
  return (
    showTermsOfUse && (
      <PopupWindow
        style={{
          background: "white",
          color: "black",
          width: "800px",
        }}
        setOpen={setShowTermsOfUse}
        open={showTermsOfUse}
      >
        <div
          style={{
            textAlign: "center",
            // marginBottom: 50,
          }}
        >
          <iframe
            src="https://legal.overwatch.ai/terms.html"
            style={{
              width: "100%",
              height: "50vh",
              border: "none",
            }}
            title="Terms of Use Policy"
          ></iframe>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              gap: 10,
              marginTop: 10,
            }}
          >
            <div
              onClick={() => {
                setShowTermsOfUse(false);
                handleLogout && handleLogout();
              }}
              style={{
                padding: "10px",
                width: 120,
                backgroundColor: "#ed2028",
                marginRight: 10,
                borderRadius: "5px",
                color: "white",
                border: "1px solid white",
                boxSizing: "border-box",
              }}
            >
              Decline
            </div>
            <div
              onClick={() => {
                setShowTermsOfUse(false);
              }}
              style={{
                padding: "10px",
                width: 120,
                backgroundColor: "#436c9a",
                marginRight: 10,
                borderRadius: "5px",
                color: "white",
                border: "1px solid white",
                boxSizing: "border-box",
              }}
            >
              Accept
            </div>
          </div>
        </div>
      </PopupWindow>
    )
  );
};

const PrivacyPolicyModal = ({
  showPrivacyPolicy,
  setShowPrivacyPolicy,
  handleLogout,
  setShowTermsOfUse,
}) => {
  return (
    showPrivacyPolicy && (
      <PopupWindow
        style={{
          background: "white",
          color: "black",
          width: "800px",
        }}
        setOpen={setShowPrivacyPolicy}
        open={showPrivacyPolicy}
      >
        <div
          style={{
            textAlign: "center",
            // marginBottom: 50,
          }}
        >
          <iframe
            src="https://legal.overwatch.ai/privacy.html"
            style={{
              width: "100%",
              height: "50vh",
              border: "none",
            }}
            title="Privacy & Cookies Policy"
          ></iframe>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              gap: 10,
              marginTop: 10,
            }}
          >
            <div
              onClick={() => {
                setShowPrivacyPolicy(false);
                handleLogout && handleLogout();
              }}
              style={{
                padding: "10px",
                width: 120,
                backgroundColor: "#ed2028",
                marginRight: 10,
                borderRadius: "5px",
                color: "white",
                border: "1px solid white",
                boxSizing: "border-box",
              }}
            >
              Decline
            </div>
            <div
              onClick={() => {
                setShowTermsOfUse && setShowTermsOfUse(true);
                setShowPrivacyPolicy(false);
              }}
              style={{
                padding: "10px",
                width: 120,
                backgroundColor: "#436c9a",
                marginRight: 10,
                borderRadius: "5px",
                color: "white",
                border: "1px solid white",
                boxSizing: "border-box",
              }}
            >
              Accept
            </div>
          </div>
        </div>
      </PopupWindow>
    )
  );
};

const PolicyButtons = ({ setShowTermsOfUse, setShowPrivacyPolicy }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: 10,
        zIndex: 100,
      }}
    >
      <div
        style={{
          padding: 20,
          height: 50,
          borderRadius: 100,
          background: "#436c9a",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 10,
          cursor: "pointer",
          color: "white",
        }}
        onClick={() => {
          setShowTermsOfUse(true);
        }}
      >
        Terms of Use Policy
      </div>
      <div
        style={{
          padding: 20,
          height: 50,
          borderRadius: 100,
          background: "#436c9a",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 10,
          cursor: "pointer",
          color: "white",
        }}
        onClick={() => {
          setShowPrivacyPolicy(true);
        }}
      >
        Privacy & Cookie Policy
      </div>
    </div>
  );
};

export { TermsOfUseModal, PrivacyPolicyModal, PolicyButtons };
